/*
  THE PRODUCT PAGE'S PHOTO VIEWER GETS ITS WAYS OUT (2026-09-29, the owner's
  brief: "tapping the magnifier opens the photo full-screen with NO way to
  close it").

  WHAT THE VIEWER IS. The magnifier in the frame's corner forwards its click to
  the shown photograph, and the theme's own Magnific Popup opens on that -
  jQuery, bundled in theme.js.liquid, started for this gallery on the phone too
  since 2026-09-23. It is given the class bc-pdp-viewer so this file and
  assets/bc-product-gallery.css can reach it without touching anyone else's
  Magnific.

  WHAT WAS MEASURED, with real touch events at 375 and on the desktop at 1920:

    375   opens, html overflow-y goes hidden (the lock works), .mfp-close comes
          out 363x44 at (12,225) - a full-width strip lying on the top edge of
          a 363x363 photograph at (6,225), at opacity .8, which is not a button
          anyone can find; a tap on the backdrop at (8,8) does NOT close;
          window.scrollY moved 242 -> 170 on open.
    1920  opens, the same strip is 1080x44 over the picture, and a click on the
          backdrop DOES close. So the desktop had one way out and the phone had
          none.

  WHAT THIS ADDS, without touching the plugin:
    - the backdrop dismisses on touch. Magnific binds its bg-click on the wrap
      and on touch that click did not reach it; a touchend whose target is the
      wrap or the bg closes here instead. A tap that started on the photograph
      never counts, so a pan cannot dismiss.
    - swipe down dismisses: 80px of downward travel with less than half that
      sideways, measured from touchstart to touchend on the wrap.
    - Escape closes (the plugin's own key handler does it; kept here for the
      case where it is not bound) and the button is in the tab order.
    - focus goes back to the MAGNIFIER, not to the photograph the click was
      forwarded to, and the page returns to the scroll position it had when the
      viewer opened.

  It hooks the plugin's lifecycle through a MutationObserver on the body rather
  than through jQuery, so nothing here depends on the plugin's callbacks or on
  its removalDelay.

  The close button itself is the plugin's own .mfp-close, restyled by
  assets/bc-product-gallery.css into the site's square bordered control at 44px
  inside the safe area; its label stays the plugin's (theme.strings.zoomClose).
*/
(function () {
  var SCOPE = 'bc-pdp-viewer';
  var openScrollY = 0;
  var opener = null;
  var wrap = null;

  function isScoped(node) {
    return node && node.classList && node.classList.contains('mfp-wrap') && node.classList.contains(SCOPE);
  }

  function rememberOpener() {
    /* The magnifier forwards its click to the photograph, so the plugin's own
       idea of what opened it is that photograph. Focus has to come back to the
       control the shopper actually pressed. */
    var button = document.querySelector('[data-bc-pgal-zoom]');
    if (button) opener = button;
  }

  function close() {
    if (!wrap) return;
    var btn = wrap.querySelector('.mfp-close');
    if (btn) { btn.click(); return; }
    document.dispatchEvent(new KeyboardEvent('keyup', { keyCode: 27, which: 27, key: 'Escape', bubbles: true }));
  }

  /*
    ONE CLOSE CONTROL, AND THE OTHER IS DELETED (2026-09-29, the owner's
    report of two crosses). Magnific's image template carries a
    <div class="mfp-close"></div> inside .mfp-figure as well as the
    <button class="mfp-close"> it puts in the wrap; with closeBtnInside false
    the div draws nothing of its own but Magnific still closes on a click
    anywhere on .mfp-close, so it is a live target lying across the top of the
    photograph - measured 363x44 at (12,225) at 375 before any of this work.
    The button is the one that survives: it is a real button, it is keyboard
    focusable, it carries title="Close (Esc)" and its own x. The div is taken
    out of the DOM, not hidden, so it leaves no dead tap target behind.
  */
  function dropSpareClose(node) {
    var spares = node.querySelectorAll('.mfp-close');
    for (var i = 0; i < spares.length; i++) {
      if (spares[i].tagName !== 'BUTTON') spares[i].remove();
    }
  }

  function bind(node) {
    wrap = node;
    dropSpareClose(node);
    openScrollY = window.scrollY || window.pageYOffset || 0;
    rememberOpener();

    firstSync = true;
    syncMedia();
    watchSlides(node);

    var startX = 0, startY = 0, onPhoto = false, moved = false;

    node.addEventListener('touchstart', function (event) {
      var t = event.touches && event.touches[0];
      if (!t) return;
      startX = t.clientX; startY = t.clientY; moved = false;
      var target = event.target;
      onPhoto = !!(target && target.closest && target.closest('.mfp-img, .mfp-figure, .mfp-arrow, .mfp-close'));
    }, { passive: true });

    node.addEventListener('touchmove', function () { moved = true; }, { passive: true });

    node.addEventListener('touchend', function (event) {
      var t = (event.changedTouches && event.changedTouches[0]) || null;
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      /* Swipe down: 80px of travel, and mostly downward. */
      if (dy > 80 && Math.abs(dx) < dy / 2) { close(); return; }

      /* A tap - it did not move and it did not begin on the picture or a
         control - on the backdrop. */
      if (!moved && !onPhoto && Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        var target = event.target;
        if (target === node || (target && target.classList && (target.classList.contains('mfp-container') || target.classList.contains('mfp-content') || target.classList.contains('mfp-bg')))) {
          close();
        }
      }
    }, { passive: true });

    node.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) close();
    });
  }

  function unbind() {
    /* Before wrap goes: nothing keeps playing behind a closed overlay. */
    dropPlayer();
    firstSync = true;
    wrap = null;
    /* The page keeps the position it had when the viewer opened, and the
       magnifier keeps the focus ring, so the keyboard is where it was. */
    if (typeof openScrollY === 'number') window.scrollTo(0, openScrollY);
    if (opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (error) { opener.focus(); }
    }
  }

  /*
    THE FILM PLAYS IN THE VIEWER TOO (2026-10-12, the owner's brief).

    The bundled Magnific registers image, zoom and gallery and nothing else -
    no inline module, no iframe module - so the plugin itself can only ever
    show a picture. The video's entry therefore carries its POSTER, which
    Magnific loads as that slide's picture, and the real player is laid over
    the figure here. Nothing in the vendored bundle is touched, and a
    photographs-only product never reaches a line of this.

    The rules are the gallery's, because a shopper should not have to learn
    two: muted so the browser will actually start it, native controls left
    alone so unmuting is one tap, from the beginning every time, paused when
    the slide is left, and nothing at all under prefers-reduced-motion. The
    viewer's own opening never autostarts - firstSync is what holds it - so
    arriving at the film is always the shopper's doing.
  */
  var player = null;
  var playerItemId = null;
  var firstSync = true;

  function currentItem() {
    var mp = window.jQuery && window.jQuery.magnificPopup && window.jQuery.magnificPopup.instance;
    if (!mp || !mp.currItem || !mp.currItem.el) return null;
    return mp.currItem.el[0] || null;
  }

  function mayAutoplay() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (error) { /* no matchMedia: treat as no preference */ }
    return true;
  }

  /* Closing, or leaving the slide, stops the film - and an external one is a
     cross-origin iframe, so taking its src away is the only way to reach it. */
  function dropPlayer() {
    if (!player) return;
    var video = player.querySelector('video');
    if (video && !video.paused) video.pause();
    var frame = player.querySelector('iframe');
    if (frame) frame.removeAttribute('src');
    if (player.parentNode) player.parentNode.removeChild(player);
    player = null;
    playerItemId = null;
  }

  /* The player is built from the one the page already carries, so the sources,
     the poster and the types stay Shopify's own and there is no second source
     of truth for what this film is. */
  function buildPlayer(item, autostart) {
    var id = item.getAttribute('data-image-id');
    var kind = item.getAttribute('data-bc-media-type');
    var origin = document.querySelector('.product-single__featured-image-wrapper[data-image-id="' + id + '"]');
    if (!origin) return null;
    var box = document.createElement('div');
    box.className = 'bc-pdp-viewer__media';

    if (kind === 'external_video') {
      var frame = origin.querySelector('iframe');
      var embed = frame && (frame.getAttribute('data-bc-embed') || frame.getAttribute('src'));
      if (!embed) return null;
      var copy = document.createElement('iframe');
      copy.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      copy.setAttribute('allowfullscreen', '');
      copy.setAttribute('title', document.title);
      var join = embed.indexOf('?') > -1 ? '&' : '?';
      var params = 'playsinline=1&' + (/vimeo/i.test(embed) ? 'muted=1' : 'mute=1') + (autostart ? '&autoplay=1' : '');
      copy.setAttribute('src', embed + join + params);
      box.appendChild(copy);
      return box;
    }

    var source = origin.querySelector('video');
    if (!source) return null;
    var video = document.createElement('video');
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.playsInline = true;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('preload', 'metadata');
    if (source.getAttribute('poster')) video.setAttribute('poster', source.getAttribute('poster'));
    var list = source.querySelectorAll('source');
    for (var i = 0; i < list.length; i++) {
      var tag = document.createElement('source');
      tag.setAttribute('src', list[i].getAttribute('src'));
      if (list[i].getAttribute('type')) tag.setAttribute('type', list[i].getAttribute('type'));
      video.appendChild(tag);
    }
    box.appendChild(video);
    return box;
  }

  function syncMedia() {
    if (!wrap) return;
    var item = currentItem();
    var kind = item && item.getAttribute('data-bc-media-type');
    if (!kind) { dropPlayer(); firstSync = false; return; }

    var id = item.getAttribute('data-image-id');
    if (player && playerItemId === id) return;
    dropPlayer();

    var figure = wrap.querySelector('.mfp-figure') || wrap.querySelector('.mfp-content');
    if (!figure) return;

    var autostart = !firstSync && mayAutoplay();
    player = buildPlayer(item, autostart);
    firstSync = false;
    if (!player) return;
    figure.appendChild(player);
    playerItemId = id;

    var video = player.querySelector('video');
    if (video && autostart) {
      try { video.currentTime = 0; } catch (error) { /* starts at 0 anyway */ }
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    }
  }

  /* Magnific swaps the whole figure when the shopper moves on, so the content
     box is watched rather than the plugin's events: this file stays vanilla
     and does not depend on which jQuery events this build happens to fire. */
  function watchSlides(node) {
    if (!window.MutationObserver) return;
    var box = node.querySelector('.mfp-container') || node;
    new MutationObserver(function () { syncMedia(); }).observe(box, { childList: true, subtree: true });
  }

  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var a = 0; a < added.length; a++) if (isScoped(added[a])) bind(added[a]);
        var removed = records[i].removedNodes;
        for (var r = 0; r < removed.length; r++) if (isScoped(removed[r])) unbind();
      }
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
